module.exports = __webpack_public_path__ + "static/logos-07-ba5907fb99386283f40c8f28b080bc8e.png";